import React from 'react'

import { Login } from '~/auth/components/Login'

export default function LoginPage() {
  // @TODO: check if we need this abstraction to make clear its a route
  return <Login />
}
